var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-layout"},[_c('navbar-dashboard'),_c('sidebar-dashboard'),_c('div',{staticClass:"dashboard-content-page"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }